<div class="frame-in">
  @if (data) {
    <div [ngClass]="{'hidden': loading}">
      <div class="introduction" [ngClass]="{'hidden':!(!gameStatus || gameStatus == 'introduction')}">
        <h2 class="title">
          <span class="main-text">Welcome</span>
          <span class="bg-text">Welcome</span>
        </h2>
        <p>
          <img src="assets/images/snail.png">
        </p>
        <button type="button" class="introduction-button" (click)="gameStart()"></button>
      </div>
      <div class="video-box letter-song" style="user-select: none!important" [ngClass]="{'hidden': !(gameStatus && gameStatus == 'start')}">
        <button type="button" class="leave-button" (click)="changeGameStatus('leave')"></button>
        <div class="letter-box video">
          <video (ended)="endVideo()" id="video" disablePictureInPicture (timeupdate)="initProgressBar()" oncontextmenu="return false;"
            controlsList="nodownload" style="object-fit: cover;">
            <source [src]="data.data.videoMp4" type="video/mp4">
          </video>
        </div>
        <div class="audio-box" [ngClass]="{'active': userActive}">
          <div class="actions-box">
            <button id="play-btn" type="button" (click)="togglePlay()" [ngClass]="{'pause': isPause}"></button>
          </div>
          <div>
            <div class="progress-box">
              <div id="sliderZone" (mouseup)="mouseUp($event,480)" (mousedown)="mouseDown($event)" (mousemove)="seek($event,480)" style="cursor: pointer!important; z-index: 999999 !important; height: 12px !important; width: 100%!important; position: absolute; margin: 0!important; padding: 0!important; display: block"></div>
              <mat-progress-bar id="seek-obj" class="progress-bar" mode="determinate" [value]="progressValue"></mat-progress-bar>
              <div class="red-dot" [ngStyle]="{'left': 'calc('+progressValue+'% - 12px)'}"></div>
            </div>
            <div class="time">
              <span class="timer">{{timer}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="leave" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'leave')}">
        <p class="text">{{data.leave.text}}</p>
        <div class="row justyfy-content-center">
          <div class="col-auto">
            <button type="button" class="leave-yes" (click)="previousState()"></button>
          </div>
          <div class="col-auto">
            <button type="button" class="leave-no" (click)="gameStart()"></button>
          </div>
        </div>
      </div>
      <div class="complete welcome" [ngClass]="{'hidden':!(gameStatus && gameStatus == 'complete')}">
        <div class="trophy"></div>
        <button type="button" class="back-to-menu" (click)="previousState()"></button>
        <button type="button" class="again" (click)="changeGameStatus('start')"></button>
        <button type="button" class="next-activity" (click)="nextActivity()"></button>
      </div>
      <audio id="completeAudio">
        <source [src]="data.completeAudios[data.completeAudios.length | randomIndex]" type="audio/wav">
      </audio>
      <audio id="warningAudio">
        <source src="assets/sounds/warning.mp3" type="audio/mpeg">
      </audio>
      <img class="frame-bg" src="assets/images/activity/introduction/introduction-bg.jpg"
        [ngClass]="{'hidden':gameStatus && gameStatus !== 'introduction'}">
        <img class="frame-bg" src="assets/images/activity/video/video-bg.jpg"
          [ngClass]="{'hidden': !gameStatus || gameStatus !== 'start'}">
          <img class="frame-bg" src="assets/images/activity/complete/bg-welcome.jpg" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'complete'}">
          <img class="frame-bg" src="assets/images/activity/leave/leave-bg.png" [ngClass]="{'hidden':!gameStatus || gameStatus !== 'leave'}">
        </div>
      }
    </div>
